import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import bcrypt from 'bcryptjs';
import { useAuth } from '../context/AuthContext';

function SignIn() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { data, error: fetchError } = await supabase
      .from('users')
      .select('*')
      .eq('email', email)
      .single();

    if (fetchError || !data) {
      setError('Invalid email or password.');
      setLoading(false);
      return;
    }

    const passwordIsValid = bcrypt.compareSync(password, data.password);

    if (passwordIsValid) {
      login({ id: data.id, email: data.email, first_name: data.first_name, last_name: data.last_name });
      navigate('/dashboard');
    } else {
      setError('Invalid email or password.');
    }

    setLoading(false);
  };

  return (
    <main className="main-content auth-page">
      <div className="auth-container">
        <h2>Sign in to ZenLog</h2>
        <form onSubmit={handleSignIn} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-confirm" disabled={loading}>
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
          {error && <p className="error-message">{error}</p>}
        </form>
      </div>
    </main>
  );
}

export default SignIn;

